// extracted by mini-css-extract-plugin
module.exports = {"container":"LegalNav_container__1c6nO","spacer":"LegalNav_spacer__AkT-8"};